import { SignatureModule } from "@enums/signatureModule";

export const signatureModulesMap = {
  partner: SignatureModule.Partners,
  news: SignatureModule.News,
  webinar: SignatureModule.Webinars,
  project: SignatureModule.Projects,
  media: SignatureModule.Media,
  award: SignatureModule.Awards,
  artist: SignatureModule.Artists,
  faq: SignatureModule.Faqs,
};

// Obtain module from pathname to get enum from signatureModelMap
export const getSignatureModule = (pathname: string) => {
  return pathname.split("/")[2] as keyof typeof signatureModulesMap;
};
